import React, {ChangeEvent, useRef } from "react";
import "./Search.scss";
export interface Props {
  searchClass?: string;
  searchId?: string;
  searchPlaceholder?: string;
  searchClick?: () => void;
  searchValue?: string;
  searchChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  searchLabelText?: string;
  searchkeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  searchkeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  searchBtnText?: any;
  searchBtnClass?: string;
  searchBtnId?: string;
  children?: any;
  clearSearchList?: any;
  mainStyle?: React.CSSProperties;
  searchContentStyle?: React.CSSProperties;
  searchLabelStyle?: React.CSSProperties;
  searchInputStyle?: React.CSSProperties;
  searchBtnStyle?: React.CSSProperties;
}

const Search = ({
  searchClass,
  searchId,
  searchPlaceholder,
  searchClick,
  searchValue,
  searchChange,
  searchLabelText,
  searchkeyDown,
  searchkeyUp,
  searchBtnText,
  searchBtnClass,
  searchBtnId,
  children,
  clearSearchList,
  mainStyle,
  searchContentStyle,
  searchLabelStyle,
  searchInputStyle,
  searchBtnStyle,
}: Props) => {
  const searchRef = useRef<any>(null);
  const clearSearch = () => {
    if (searchRef?.current) {
      searchRef.current.value = "";
    }
  };
  return (
    <div className={`mfg-search${searchClass ? " " + searchClass : ""}`} style={mainStyle && mainStyle}>
      <div className={`search-container`}>
        {searchLabelText && <label htmlFor={searchId} style={searchLabelStyle && searchLabelStyle}>{searchLabelText}</label>}
        <input
          type="search"
          value={searchValue}
          onChange={searchChange}
          id={searchId && searchId}
          placeholder={searchPlaceholder}
          onKeyDown={searchkeyDown}
          onKeyUp={searchkeyUp}
          ref={searchRef}
          style={searchInputStyle && searchInputStyle}
        />
        {searchRef.current && !searchRef.current.value && (
          <button
            className={`srchBtn${searchBtnClass ? " " + searchBtnClass : ""}`}
            id={searchBtnId}
            onClick={searchClick}
            style={searchBtnStyle && searchBtnStyle}
          >
            {searchBtnText ? searchBtnText : "Search"}
          </button>
        )}
        {searchRef.current && searchRef.current.value && (
          <button
            className="clear-search"
            style={searchBtnStyle && searchBtnStyle}
            onClick={() => {
              if (clearSearch && clearSearchList) {
                clearSearch();
                clearSearchList();
              }
            }}
          >
            X
          </button>
        )}
      </div>
      {children && <div className="search-results" style={searchContentStyle && searchContentStyle}>{children}</div>}
    </div>
  );
};

export default Search;
